import { checkValue } from 'utils';
import { renderWithTooltip } from 'utils/table';

export const columns = [
  {
    title: 'Код НУ для зачисления в бюджет',
    dataIndex: 'number',
    key: 'number',
  },
  {
    title: 'Наименование бенефициара',
    dataIndex: 'name',
    key: 'name',
    render: (value) => renderWithTooltip(value),
  },
  {
    title: 'БИН бенефициара',
    dataIndex: 'requisite',
    key: 'requisite',
  },
  {
    title: 'Город',
    dataIndex: 'region',
    key: 'region',
    render: (value) => {
      if (!value?.parent) {
        return checkValue(value?.name_rus);
      }

      return checkValue(value?.parent?.name_rus);
    },
  },
];
